module.exports = __webpack_public_path__ + "img/spartan-demolition-sitework-04-tablet.37efc027.jpg";